export default "__VITE_ASSET__DOjQt0um__"